module.exports = __webpack_public_path__ + "img/register-user-icon@2x.9fe5c60b.png";